module.exports = __webpack_public_path__ + "img/img_process_con4.caf5f2ef.png";